import { z } from 'zod';

const AmountRawSchema = z
  .string()
  .regex(/^-?\d+$/)
  .transform(BigInt);

export const LimitOrderStatusSchema = z.enum([
  'pending_signature',
  'open',
  'filled',
  'cancelled',
  'expired',
]);

export const LimitOrderTypeSchema = z.enum(['limit', 'stop_loss', 'take_profit']);

export const LimitOrderSchema = z.object({
  id: z.string(),
  network: z.string(),
  provider: z.string(),
  orderId: z.string().nullable(),
  userAddress: z.string(),
  fromToken: z.string(),
  toToken: z.string(),
  fromAmount: AmountRawSchema,
  toAmount: AmountRawSchema,
  feeAmount: z.string(),
  feeBps: z.number().int(),
  status: LimitOrderStatusSchema,
  orderType: LimitOrderTypeSchema,
  triggerPriceUsd: z.string().nullable(),
  expiresAt: z.union([z.string(), z.number()]).nullable(),
  txHash: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const LimitOrderListSchema = z.array(LimitOrderSchema);

export type LimitOrder = z.infer<typeof LimitOrderSchema>;
export type LimitOrderStatus = z.infer<typeof LimitOrderStatusSchema>;
export type LimitOrderType = z.infer<typeof LimitOrderTypeSchema>;

export const BuildLimitOrderResultSchema = z.object({
  localOrderId: z.string(),
  provider: z.string(),
  status: LimitOrderStatusSchema,
  feeBps: z.number().int(),
  feeAmount: z.string(),
  priceImpactPct: z.number(),
  orderData: z.unknown(),
});

export type BuildLimitOrderResult = z.infer<typeof BuildLimitOrderResultSchema>;

export interface BuildLimitOrderDto {
  network: string;
  fromToken: string;
  toToken: string;
  fromAmount: string;
  toAmount: string;
  userAddress: string;
  orderType?: LimitOrderType;
  triggerPriceUsd?: string;
  expiresAt?: number;
  receiverAddress?: string;
  slippageBps?: number;
}
